import React, { useMemo } from 'react'
import Breadcrumb from '../../components/common/Breadcrumb'
import ReactApexChart from 'react-apexcharts';
import ReactDataTable from 'react-data-table-component';
import { IconEdit, IconTrash } from '@tabler/icons-react';

export default function Ticket() {

    const chartData1 = {
        series: [6, 4, 8],
        options: {
            labels: ['Quarter 1', 'Quarter 2', 'Quarter 4'],
            colors: ['var(--chart-color1)', 'var(--chart-color2)', 'var(--chart-color3)'],
            legend: {
                show: false,
            },
            stroke: {
                colors: 'var(--bg-dark)'
            },
            dataLabels: {
                enabled: false,
            },
        },
    };

    const chartData2 = {
        series: [240, 1038],
        options: {
            labels: ["Resolved", "Solved"],
            colors: ['var(--chart-color1)', 'var(--chart-color2)'],
            legend: {
                show: false,
            },
            dataLabels: {
                enabled: false,
            },
            stroke: {
                colors: 'var(--bg-dark)'
            },
            plotOptions: {
                pie: {
                    expandOnClick: false,
                    donut: {
                        labels: {
                            show: false,
                        }
                    }
                }
            },
        },
    };

    const chartData3 = {
        series: [521, 1021],
        options: {
            labels: ["Pending", "All"],
            colors: ['var(--chart-color3)', 'var(--chart-color4)'],
            legend: {
                show: false,
            },
            dataLabels: {
                enabled: false,
            },
            stroke: {
                colors: 'var(--bg-dark)'
            },
            plotOptions: {
                pie: {
                    expandOnClick: false,
                    donut: {
                        labels: {
                            show: false,
                        }
                    }
                }
            },
        },
    };

    const chartData4 = {
        series: [978, 822],
        options: {
            labels: ["Responded", "All"],
            colors: ['var(--chart-color5)', 'var(--chart-color1)'],
            legend: {
                show: false,
            },
            dataLabels: {
                enabled: false,
            },
            stroke: {
                colors: 'var(--bg-dark)'
            },
            plotOptions: {
                pie: {
                    expandOnClick: false,
                    donut: {
                        labels: {
                            show: false,
                        }
                    }
                }
            },
        },
    };

    const columnsFilter = [
        {
            name: 'ID',
            selector: row => row.id,
            sortable: true,
            width: '100px',
        },
        {
            name: 'Assign By',
            selector: row => row.assignBy,
            sortable: true,
        },
        {
            name: 'Assign To',
            selector: row => row.assignTo,
            sortable: true,
        },
        {
            name: 'Email',
            selector: row => row.email,
            sortable: true,
        },
        {
            name: 'Subject',
            selector: row => row.subject,
            sortable: true,
        },
        {
            name: 'Status',
            selector: row => row.status,
        },
        {
            name: 'Date',
            selector: row => row.date,
            sortable: true,
        },
        {
            name: 'Action',
            selector: row => row.action,
        },
    ];

    const dataFilter = [
        {
            id: '231',
            assignBy: 'Airi Satou',
            assignTo: 'Angelica Ramos',
            email: 'airi@example.com',
            subject: 'New Code Update',
            status: <span className='inline-block py-1 px-2 uppercase text-[10.5px]/[12px] bg-yellow text-white rounded'>Pending</span>,
            date: '24-04-2021',
            action:
                <div className='flex items-stretch gap-10'>
                    <button className='bg-sky rounded-[4px] px-10 py-[8px]'>
                        <IconEdit className='text-white w-[18px] h-[18px]' />
                    </button>
                    <button className='bg-danger rounded-[4px] px-10 py-[8px]'>
                        <IconTrash className='text-white w-[18px] h-[18px]' />
                    </button>
                </div>,
        },
        {
            id: '235',
            assignBy: 'Brenden Wagner',
            assignTo: 'Ashton Cox',
            email: 'airi@example.com',
            subject: 'New Code Update',
            status: <span className='inline-block py-1 px-2 uppercase text-[10.5px]/[12px] bg-success text-white rounded'>Complete</span>,
            date: '24-04-2021',
            action:
                <div className='flex items-stretch gap-10'>
                    <button className='bg-sky rounded-[4px] px-10 py-[8px]'>
                        <IconEdit className='text-white w-[18px] h-[18px]' />
                    </button>
                    <button className='bg-danger rounded-[4px] px-10 py-[8px]'>
                        <IconTrash className='text-white w-[18px] h-[18px]' />
                    </button>
                </div>,
        },
        {
            id: '236',
            assignBy: 'Bradley Greer',
            assignTo: 'Cara Stevens',
            email: 'airi@example.com',
            subject: 'New Code Update',
            status: <span className='inline-block py-1 px-2 uppercase text-[10.5px]/[12px] bg-success text-white rounded'>Complete</span>,
            date: '24-04-2021',
            action:
                <div className='flex items-stretch gap-10'>
                    <button className='bg-sky rounded-[4px] px-10 py-[8px]'>
                        <IconEdit className='text-white w-[18px] h-[18px]' />
                    </button>
                    <button className='bg-danger rounded-[4px] px-10 py-[8px]'>
                        <IconTrash className='text-white w-[18px] h-[18px]' />
                    </button>
                </div>,
        },
        {
            id: '245',
            assignBy: 'Cara Stevens',
            assignTo: 'Airi Satou',
            email: 'airi@example.com',
            subject: 'New Code Update',
            status: <span className='inline-block py-1 px-2 uppercase text-[10.5px]/[12px] bg-yellow text-white rounded'>Pending</span>,
            date: '24-04-2021',
            action:
                <div className='flex items-stretch gap-10'>
                    <button className='bg-sky rounded-[4px] px-10 py-[8px]'>
                        <IconEdit className='text-white w-[18px] h-[18px]' />
                    </button>
                    <button className='bg-danger rounded-[4px] px-10 py-[8px]'>
                        <IconTrash className='text-white w-[18px] h-[18px]' />
                    </button>
                </div>,
        },
        {
            id: '246',
            assignBy: 'Airi Satou',
            assignTo: 'Angelica Ramos',
            email: 'airi@example.com',
            subject: 'New Code Update',
            status: <span className='inline-block py-1 px-2 uppercase text-[10.5px]/[12px] bg-yellow text-white rounded'>Pending</span>,
            date: '24-04-2021',
            action:
                <div className='flex items-stretch gap-10'>
                    <button className='bg-sky rounded-[4px] px-10 py-[8px]'>
                        <IconEdit className='text-white w-[18px] h-[18px]' />
                    </button>
                    <button className='bg-danger rounded-[4px] px-10 py-[8px]'>
                        <IconTrash className='text-white w-[18px] h-[18px]' />
                    </button>
                </div>,
        },
        {
            id: '247',
            assignBy: 'Brenden Wagner',
            assignTo: 'Ashton Cox',
            email: 'airi@example.com',
            subject: 'New Code Update',
            status: <span className='inline-block py-1 px-2 uppercase text-[10.5px]/[12px] bg-success text-white rounded'>Complete</span>,
            date: '24-04-2021',
            action:
                <div className='flex items-stretch gap-10'>
                    <button className='bg-sky rounded-[4px] px-10 py-[8px]'>
                        <IconEdit className='text-white w-[18px] h-[18px]' />
                    </button>
                    <button className='bg-danger rounded-[4px] px-10 py-[8px]'>
                        <IconTrash className='text-white w-[18px] h-[18px]' />
                    </button>
                </div>,
        },
        {
            id: '248',
            assignBy: 'Bradley Greer',
            assignTo: 'Cara Stevens',
            email: 'airi@example.com',
            subject: 'New Code Update',
            status: <span className='inline-block py-1 px-2 uppercase text-[10.5px]/[12px] bg-success text-white rounded'>Complete</span>,
            date: '24-04-2021',
            action:
                <div className='flex items-stretch gap-10'>
                    <button className='bg-sky rounded-[4px] px-10 py-[8px]'>
                        <IconEdit className='text-white w-[18px] h-[18px]' />
                    </button>
                    <button className='bg-danger rounded-[4px] px-10 py-[8px]'>
                        <IconTrash className='text-white w-[18px] h-[18px]' />
                    </button>
                </div>,
        },
        {
            id: '249',
            assignBy: 'Cara Stevens',
            assignTo: 'Airi Satou',
            email: 'airi@example.com',
            subject: 'New Code Update',
            status: <span className='inline-block py-1 px-2 uppercase text-[10.5px]/[12px] bg-yellow text-white rounded'>Pending</span>,
            date: '24-04-2021',
            action:
                <div className='flex items-stretch gap-10'>
                    <button className='bg-sky rounded-[4px] px-10 py-[8px]'>
                        <IconEdit className='text-white w-[18px] h-[18px]' />
                    </button>
                    <button className='bg-danger rounded-[4px] px-10 py-[8px]'>
                        <IconTrash className='text-white w-[18px] h-[18px]' />
                    </button>
                </div>,
        },
        {
            id: '250',
            assignBy: 'Airi Satou',
            assignTo: 'Angelica Ramos',
            email: 'airi@example.com',
            subject: 'New Code Update',
            status: <span className='inline-block py-1 px-2 uppercase text-[10.5px]/[12px] bg-yellow text-white rounded'>Pending</span>,
            date: '24-04-2021',
            action:
                <div className='flex items-stretch gap-10'>
                    <button className='bg-sky rounded-[4px] px-10 py-[8px]'>
                        <IconEdit className='text-white w-[18px] h-[18px]' />
                    </button>
                    <button className='bg-danger rounded-[4px] px-10 py-[8px]'>
                        <IconTrash className='text-white w-[18px] h-[18px]' />
                    </button>
                </div>,
        },
        {
            id: '251',
            assignBy: 'Brenden Wagner',
            assignTo: 'Ashton Cox',
            email: 'airi@example.com',
            subject: 'New Code Update',
            status: <span className='inline-block py-1 px-2 uppercase text-[10.5px]/[12px] bg-success text-white rounded'>Complete</span>,
            date: '24-04-2021',
            action:
                <div className='flex items-stretch gap-10'>
                    <button className='bg-sky rounded-[4px] px-10 py-[8px]'>
                        <IconEdit className='text-white w-[18px] h-[18px]' />
                    </button>
                    <button className='bg-danger rounded-[4px] px-10 py-[8px]'>
                        <IconTrash className='text-white w-[18px] h-[18px]' />
                    </button>
                </div>,
        },
        {
            id: '252',
            assignBy: 'Bradley Greer',
            assignTo: 'Cara Stevens',
            email: 'airi@example.com',
            subject: 'New Code Update',
            status: <span className='inline-block py-1 px-2 uppercase text-[10.5px]/[12px] bg-success text-white rounded'>Complete</span>,
            date: '24-04-2021',
            action:
                <div className='flex items-stretch gap-10'>
                    <button className='bg-sky rounded-[4px] px-10 py-[8px]'>
                        <IconEdit className='text-white w-[18px] h-[18px]' />
                    </button>
                    <button className='bg-danger rounded-[4px] px-10 py-[8px]'>
                        <IconTrash className='text-white w-[18px] h-[18px]' />
                    </button>
                </div>,
        },
        {
            id: '253',
            assignBy: 'Cara Stevens',
            assignTo: 'Airi Satou',
            email: 'airi@example.com',
            subject: 'New Code Update',
            status: <span className='inline-block py-1 px-2 uppercase text-[10.5px]/[12px] bg-yellow text-white rounded'>Pending</span>,
            date: '24-04-2021',
            action:
                <div className='flex items-stretch gap-10'>
                    <button className='bg-sky rounded-[4px] px-10 py-[8px]'>
                        <IconEdit className='text-white w-[18px] h-[18px]' />
                    </button>
                    <button className='bg-danger rounded-[4px] px-10 py-[8px]'>
                        <IconTrash className='text-white w-[18px] h-[18px]' />
                    </button>
                </div>,
        },
    ]

    const [filterText, setFilterText] = React.useState('');
    const [resetPaginationToggle, setResetPaginationToggle] = React.useState(false);
    const filteredItems = dataFilter.filter(
        item =>
            item.id.toLowerCase().includes(filterText.toLowerCase()) ||
            item.assignBy.toLowerCase().includes(filterText.toLowerCase()) ||
            item.assignTo.toLowerCase().includes(filterText.toLowerCase()) ||
            item.email.toLowerCase().includes(filterText.toLowerCase()) ||
            item.subject.toLowerCase().includes(filterText.toLowerCase()) ||
            item.data.toLowerCase().includes(filterText.toLowerCase())
    );

    const subHeaderComponentMemo = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText('');
            }
        };

        return (
            <div className='flex gap-5 mb-10 w-full justify-end'>
                <div className='relative w-full max-w-[221px]'>
                    <input
                        type='text'
                        id='search'
                        value={filterText}
                        onChange={e => setFilterText(e.target.value)}
                        placeholder='Search here...'
                        className='bg-bg-light border border-border w-full py-[6px] px-3 min-h-[40px] rounded-[4px] placeholder:text-text-secondary focus:outline-none'
                    />
                </div>
                <button onClick={handleClear} className="btn btn-danger">
                    Clear
                </button>
            </div>
        );
    }, [filterText, resetPaginationToggle]);

    return (
        <>
            <Breadcrumb title="Tickets" path="Tickets" />
            <div className='grid xl:grid-cols-4 md:grid-cols-2 grid-cols-1 gap-30 mb-30'>
                <div className='bg-bg-dark rounded-lg shadow-light text-center md:p-20 p-15 flex flex-col justify-center items-center'>
                    <ReactApexChart options={chartData1.options} series={chartData1.series} type="pie" width={150} />
                    <p className='my-2 text-[28px]/[33.6px] font-medium'>
                        2078
                    </p>
                    <p className='text-text-secondary'>
                        Total Tickets
                    </p>
                </div>
                <div className='bg-bg-dark rounded-lg shadow-light text-center md:p-20 p-15 flex flex-col justify-center items-center'>
                    <ReactApexChart options={chartData2.options} series={chartData2.series} type="donut" height={130} />
                    <p className='my-2 text-[28px]/[33.6px] font-medium'>
                        1278
                    </p>
                    <p className='text-text-secondary'>
                        Resolve
                    </p>
                </div>
                <div className='bg-bg-dark rounded-lg shadow-light text-center md:p-20 p-15 flex flex-col justify-center items-center'>
                    <ReactApexChart options={chartData3.options} series={chartData3.series} type="donut" height={130} />
                    <p className='my-2 text-[28px]/[33.6px] font-medium'>
                        521
                    </p>
                    <p className='text-text-secondary'>
                        Pending
                    </p>
                </div>
                <div className='bg-bg-dark rounded-lg shadow-light text-center md:p-20 p-15 flex flex-col justify-center items-center'>
                    <ReactApexChart options={chartData4.options} series={chartData4.series} type="donut" height={130} />
                    <p className='my-2 text-[28px]/[33.6px] font-medium'>
                        978
                    </p>
                    <p className='text-text-secondary'>
                        Responded
                    </p>
                </div>
            </div>
            <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
                <div className='flex items-center justify-between gap-15 mb-30'>
                    <p className='text-[16px]/[19.2px] font-medium'>
                        Support & Ticket List
                    </p>
                </div>
                <div className='react-data-table'>
                    <ReactDataTable
                        columns={columnsFilter}
                        data={filteredItems}
                        pagination
                        paginationResetDefaultPage={resetPaginationToggle}
                        subHeader
                        subHeaderComponent={subHeaderComponentMemo}
                    />
                </div>
            </div>
        </>
    )
}
